// JS to run on all new work pages
import $ from 'jquery';
import AOS from 'aos';
import Skrollr from 'skrollr';
import initSwiperCarousel from './swiper';

let skrollr;

function initWorkHeroWipe() {
  const workHero = $('.work-hero');
  const imageEl = workHero.find('.work-hero__image');
  const body = $('body');

  function animateHero() {
    workHero.find('.work-hero__overlay').addClass('work-hero__overlay--animated');
    body.addClass('kg-transparent-header--animating').removeClass('kg-transparent-header');
    setTimeout(function () {
      body.removeClass('kg-transparent-header--animating');
    }, 1000); // kind of ugly, but we need to remove the css transition properties so that the normal hover transitions work
  }

  if (!imageEl[0].complete) {
    let timer = setTimeout(animateHero, 2000); // max amount of time to wait for the image to load

    imageEl.on('load', function () {
      clearTimeout(timer);
      animateHero();
    });
  } else {
    animateHero();
  }
}

function initWorkParallax() {
  skrollr = Skrollr.init({
    forceHeight: false,
    render: () => {
      AOS.refresh();
    },
    beforerender: (props) => {
      // on the work pages we only show the animations going down, and never repeat them
      if (props.direction === 'up') {
        return false;
      }
    },
    mobileCheck: () => {
      // overrides isMobile()
      return $(window).width() < 992;
    }
  });

  // don't do skrollr on mobile
  if (skrollr.isMobile()) {
    skrollr.destroy();
  } else {
    $(window).on('load', skrollr.refresh);
  }
}

export default {
  init() {

    const $swiperButtons = {
      next: '.swiper-button-next',
      prev: '.swiper-button-prev'
    };
    initWorkHeroWipe();
    initWorkParallax();
    initSwiperCarousel('.swiper-container', $swiperButtons);

    const observer = new ResizeObserver(() => {
      AOS.refresh();
      try {
        if (skrollr) {
          skrollr.refresh();
        }
      } catch(_) {
        // ignore failed refresh; not important -- best effort only here
      }
    });

    observer.observe(document.querySelector('.work-hero'));
  },
  finalize() {

  },
};
